module.exports = __webpack_public_path__ + "img/terroir-4.ddb1bc90.jpg";